import { memo, useCallback, useEffect, useMemo, useRef } from 'react';
import { I_Media } from 'containers/Home/types';
import FancyboxContainer, { Type_RefFuncFancybox } from '@components/Fancybox';

interface Props {
  startIndex: number;
  galleries: I_Media[];
  onClose: () => void;
}

const Fancybox = memo(({ galleries = [], startIndex = 0, onClose }: Props) => {
  const fancyboxRef = useRef<Type_RefFuncFancybox>(null!);

  const options = useMemo(
    () => ({
      infinite: false,
      startIndex,
      on: {
        destroy: () => onClose(),
      },
    }),
    [onClose, startIndex],
  );

  const renderContent = useCallback(() => {
    fancyboxRef.current?.getRoot().show(
      galleries.map(item => ({
        src: item.src,
        type: 'image',
      })),
      options,
    );
  }, [galleries, options]);

  useEffect(() => {
    renderContent();
  }, [renderContent]);

  return (
    <FancyboxContainer
      ref={fancyboxRef}
      options={{
        on: {
          destroy: () => onClose(),
        },
      }}
    >
      <a
        data-fancybox="gallery"
        href="https://lipsum.app/id/3/800x600"
        className="el-hide"
      >
        Panoee
      </a>
    </FancyboxContainer>
  );
});

export default Fancybox;
